export enum UserRole {
  Admin = 'admin',
  TenantUser = 'tenant_user',
  TenantAdmin = 'tenant_admin',
}

export enum SsoApplication {
  ADMIN = 'admin',
  USER = 'user',
}

export enum CourseStepStatus {
  Locked = 'Locked',
  Active = 'Active',
  Completed = 'Completed',
}

export enum JourneyStage {
  PRE_TRAINING = 'PreTraining',
  INTRODUCTION = 'Introduction',
  HOW_TO_PLAY = 'HowToPlay',
  POST_TRAINING = 'PostTraining',
}

export enum VerifyCodeType {
  Email = 'email',
  Phone = 'phone',
}

export enum CourseSubmissionStatus {
  ACTIVE = 'active',
  OUTDATED = 'outdated',
  COMPLETED = 'completed',
  DISCARDED = 'discarded',
}

export enum EnrollmentType {
  CHILD = 'child',
}

export enum TranslationState {
  NONE = 'none',
  IN_PROGRESS = 'in_progress',
  FAILED = 'failed',
  OUTDATED = 'outdated',
  COMPLETED = 'completed',
}
